/**
 * Site Visibility Configuration
 * 
 * Zet pagina's en secties aan/uit met true/false.
 * De code blijft bestaan - alleen de zichtbaarheid verandert.
 * Zet alles weer op true om te herstellen.
 */

export const siteVisibility = {
  // Pagina's
  pages: {
    companies: false,
    consultants: false,
    expertise: true,
    succesverhalen: true,
    aboutUs: false,
    blog: false,
    vacatures: false,
  },

  // Homepage secties
  homeSections: {
    forCompanies: false,
    forConsultants: true,
    clients: true,
    projects: true,
    testimonials: false,
    about: true,
    whyChoose: true,
    pricing: false,
    team: true,
    mission: true,
    contact: false,
    partners: false,
  },

  // Contact sectie onderdelen
  contact: {
    brochureButton: false,
  },
};
